import _ from 'lodash';

export class ImageHelper {
  static STANDARD_IMAGE_SIZE = 200000000;
  static STANDARD_AUDIO_SIZE = 200000000;

  static STANDARD_MEDIA_SIZE = 20000000;
  static STANDARD_OBJ_SIZE = 500000000;
  static STANDARD_MTL_SIZE = 100000000;
  static STANDARD_ZIP_SIZE = 1000000000;
  static STANDARD_VIDEO_SIZE = 1024000000;
  static videoFormat = [
    'mp4',
    'mp3',
    '3gp',
    'flv',
    'ogg',
    'wmv',
    'webm',
    'MOV'
  ];

  static isImageSizeExceeded(size: number) {
    return size > ImageHelper.STANDARD_IMAGE_SIZE;
  }

  static isAudioSizeExceeded(size: number) {
    return size > ImageHelper.STANDARD_AUDIO_SIZE;
  }

  static isMediaSizeExceeded(size: number) {
    return size > ImageHelper.STANDARD_MEDIA_SIZE;
  }

  static isVideoSizeExceeded(size: number) {
    return size > ImageHelper.STANDARD_VIDEO_SIZE;
  }

  static isObjSizeExceeded(size: number) {
    return size > ImageHelper.STANDARD_OBJ_SIZE;
  }

  static isMtlSizeExceeded(size: number) {
    return size > ImageHelper.STANDARD_MTL_SIZE;
  }

  static isZipImageSizeExceeded(size: number) {
    return size > ImageHelper.STANDARD_ZIP_SIZE;
  }

  static isImageTypeValid(imageType: string) {
    if (imageType === 'jpeg') {
      return false;
    } else if (imageType === 'jpg') {
      return false;
    } else if (imageType === 'png') {
      return false;
    } else if (imageType === 'svg') {
      return false;
    } else {
      return true;
    }
  }

  static isAudioTypeValid(audioType: string) {
    if (audioType.toLowerCase() === 'mpga') {
      return false;
    } else if (audioType.toLowerCase() === 'wav') {
      return false;
    } else if (audioType.toLowerCase() === 'mp3') {
      return false;
    } else if (audioType.toLowerCase() === 'ogg') {
      return false;
    } else if (audioType.toLowerCase() === 'pcm') {
    } else {
      return true;
    }
  }

  static isVideoTypeValid(videoType: string) {
    return _.includes(ImageHelper.videoFormat, videoType);
  }

  static isDocumentTypeValid(imageType: string) {
    if (imageType === 'pdf') {
      return false;
    } else if (imageType === 'docx') {
      return false;
    } else if (imageType === 'doc') {
      return false;
    } else {
      return true;
    }
  }

  static isMediaTypeValid(mediaType: string) {
    // if (mediaType === 'jpeg') {
    //   return false;
    // } else if (mediaType === 'jpg') {
    //   return false;
    // } else if (mediaType === 'png') {
    //   return false;
    // } else if (mediaType === 'mp3') {
    //   return false;
    // } else {
    //   return true;
    // }
    if (mediaType === 'jpeg') {
      return false;
    } else if (mediaType === 'jpg') {
      return false;
    } else if (mediaType === 'png') {
      return false;
    } else {
      return true;
    }
  }

}
